"use client"

import { ProductItemCard } from "@/components/product/ProductItemCard"
import { getFixedT } from "@/languages/i18n"
import { Product } from "@/types/types"
import { twMerge } from "tailwind-merge"
import { TamdaExpressProductListSkeleton } from "./TamdaExpressProductListSkeleton"

export interface TamdaExpressProductListContentProps {
  products: Product[]
  loading: boolean
  error: string | null
  title?: string
  className?: string
  locale?: string
}

export const TamdaExpressProductListContent: React.FC<TamdaExpressProductListContentProps> = ({
  products,
  loading,
  error,
  title,
  className,
  locale,
}) => {
  const t = getFixedT(locale)
  if (loading) {
    return (
      <div className={twMerge("w-full", className)}>
        <h2 className="text-xl sm:text-2xl font-bold text-[#333] mb-6 uppercase">
          {title || t("RECOMMENDED PRODUCTS")}
        </h2>
        <TamdaExpressProductListSkeleton />
      </div>
    )
  }

  if (error) {
    return (
      <div className={twMerge("w-full", className)}>
        <p className="text-red-500 text-center py-8">{error}</p>
      </div>
    )
  }

  if (!products || products.length === 0) {
    return null
  }

  return (
    <div className={twMerge("w-full", className)}>
      <h2 className="text-xl sm:text-2xl font-bold text-[#333] mb-6 uppercase">{title || t("RECOMMENDED PRODUCTS")}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 gap-y-6 sm:gap-0">
        {products.map(product => {
          const imageUrl = product.image?.lg || product.image?.origin || ""
          const stockText = `${t("In stock")} > ${product.inStockCount}`
          const bundleSizeText = `${product.bundleSize}ks/krt`

          return (
            <ProductItemCard
              key={product.id}
              title={product.name}
              url={imageUrl}
              salePrice={product.bundlePrice}
              price={product.originPrice}
              category={stockText}
              weight={bundleSizeText}
              productUrl={product.url}
              discountPercentage={product.discountPercentage}
            />
          )
        })}
      </div>
    </div>
  )
}
